module.exports = __webpack_public_path__ + "img/IMAGE3MESINPUNCH.e34289c8.jpeg";